import { getAssetBasePath } from 'src/utils/get-asset-base-path';
import type { Board } from 'chessboard/model/board/types';

/**
 * Get the piece base URL.
 */
export function getLegacyPieceBaseURL(
  pieceStylePath: string,
  size: number = 150,
  options?: Board.Options,
) {
  return `${getAssetBasePath(options)}/chess-themes/pieces/${pieceStylePath}/${size}`;
}
